let cachedTree = null;

export default function parseNavigation() {
  if (cachedTree) return cachedTree;

  const root = document.querySelector("#sz-nav-source > ul");
  if (!root) return [];

  function parseList(ul) {
    const items = [];

    for (const li of ul.children) {
      if (li.tagName !== "LI") continue;

      const link = li.firstElementChild;
      if (!link || link.tagName !== "A") continue;

      const childList = link.nextElementSibling;

      items.push({
        label: link.textContent.trim(),
        url: String(link.getAttribute("href") || "").trim(),
        children:
          childList && childList.tagName === "UL" ? parseList(childList) : [],
      });
    }

    return items;
  }

  cachedTree = parseList(root);

  return cachedTree;
}
